/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type SignatureBlockFieldVisibility = "HIDE" | "SHOW" | "%future added value";
export type SignatureTypeEnum = "PAD" | "TYPED" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractContainer_node$ref: FragmentReference;
export type ContractContainer_node = {|
  +id: string,
  +title: ?string,
  +terms: ?string,
  +can_edit: ?boolean,
  +deletable: ?boolean,
  +editable: ?boolean,
  +share_token: ?string,
  +brand_logo_url: ?string,
  +brand_header: ?string,
  +contract_event_segments: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +start_at: ?any,
        +end_at: ?any,
        +time_zone: ?string,
        +all_day: ?boolean,
        +location: ?string,
        +line1: ?string,
        +line2: ?string,
        +city: ?string,
        +province: ?string,
        +postal_code: ?string,
        +room: ?string,
        +notes: ?string,
      |}
    |}>
  |},
  +contract_line_items: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +position: ?number,
        +price_cents: ?number,
        +price_currency: ?string,
        +quantity: ?number,
        +title: ?string,
      |}
    |}>
  |},
  +contract_signature_blocks: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +address: ?string,
        +address_visibility: ?SignatureBlockFieldVisibility,
        +company_name: ?string,
        +company_name_visibility: ?SignatureBlockFieldVisibility,
        +email: ?string,
        +email_visibility: ?SignatureBlockFieldVisibility,
        +name: ?string,
        +name_visibility: ?SignatureBlockFieldVisibility,
        +phone: ?string,
        +phone_visibility: ?SignatureBlockFieldVisibility,
        +signature_type: ?SignatureTypeEnum,
        +signature_typed_name: ?string,
        +signature_url: ?string,
        +signed_at: ?any,
        +signer_fills_fields: ?boolean,
        +signing_party: ?string,
        +share_token: ?string,
        +title: ?string,
        +title_visibility: ?SignatureBlockFieldVisibility,
      |}
    |}>
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +event: ?{|
          +id: string,
          +user_contacts: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +first_name: ?string,
                +last_name: ?string,
                +user_contact_emails: ?{|
                  +edges: ?$ReadOnlyArray<?{|
                    +node: ?{|
                      +address: ?string
                    |}
                  |}>
                |},
              |}
            |}>
          |},
        |},
      |}
    |}>
  |},
  +$refType: ContractContainer_node$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "share_token",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContractContainer_node",
  "type": "Contract",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "contract_event_segments"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "contract_line_items"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "contract_signature_blocks"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    v0,
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "terms",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "can_edit",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "deletable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "editable",
      "args": null,
      "storageKey": null
    },
    v2,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_logo_url",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "brand_header",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "contract_event_segments",
      "name": "__ContractContainer_contract_event_segments_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractEventSegmentConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ContractEventSegmentEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractEventSegment",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line1",
                  "args": null,
                  "storageKey": null
                },
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "time_zone",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "all_day",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "location",
                  "args": null,
                  "storageKey": null
                },
                v2,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "line2",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "city",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "province",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "postal_code",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "room",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notes",
                  "args": null,
                  "storageKey": null
                },
                v3
              ]
            },
            v4
          ]
        },
        v5
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "contract_line_items",
      "name": "__ContractContainer_contract_line_items_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractLineItemConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ContractLineItemEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractLineItem",
              "plural": false,
              "selections": [
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_cents",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price_currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "quantity",
                  "args": null,
                  "storageKey": null
                },
                v2,
                v3
              ]
            },
            v4
          ]
        },
        v5
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "contract_signature_blocks",
      "name": "__ContractContainer_contract_signature_blocks_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ContractSignatureBlockConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ContractSignatureBlockEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractSignatureBlock",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone_visibility",
                  "args": null,
                  "storageKey": null
                },
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "address_visibility",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "company_name_visibility",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email_visibility",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name_visibility",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phone",
                  "args": null,
                  "storageKey": null
                },
                v6,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_type",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_typed_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signature_url",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signed_at",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signer_fills_fields",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "signing_party",
                  "args": null,
                  "storageKey": null
                },
                v0,
                v2,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title_visibility",
                  "args": null,
                  "storageKey": null
                },
                v3
              ]
            },
            v4
          ]
        },
        v5
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "workspaces",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkspaceEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Workspace",
              "plural": false,
              "selections": [
                v1,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [
                    v1,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "user_contacts",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EventUserContactConnectionWithRole",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "EventUserContactEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "UserContact",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "first_name",
                                  "args": null,
                                  "storageKey": null
                                },
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "last_name",
                                  "args": null,
                                  "storageKey": null
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "user_contact_emails",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "UserContactEmailConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "edges",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "UserContactEmailEdge",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "alias": null,
                                          "name": "node",
                                          "storageKey": null,
                                          "args": null,
                                          "concreteType": "UserContactEmail",
                                          "plural": false,
                                          "selections": [
                                            v6
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f0aa52e9b1da6498ceb4da57d60f6b3';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/__generated__/ContractContainer_node.graphql.js